import produce from 'immer';

import {StepItemStatus} from 'ui-library/StepNav';

import {FileListingGraphQL} from '../../../graphql-fragments/files/__generated/FileListingGraphQL';
import {ImportConnectionFilesModalState, StepKey} from './ConnectionFilesConstants';

export enum ImportConnectionFilesModalActionType {
  IS_IMPORTING = 'IS_IMPORTING',
  IS_RETRIEVING = 'IS_RETRIEVING',
  SELECT_ROW = 'SELECT_ROW',
  SET_CONNECTION_FILES = 'SET_CONNECTION_FILES',
  SET_PROCESS_CONNECTION_FILES = 'SET_PROCESS_CONNECTION_FILES',
  UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP',
}

interface IsImportingAction {
  type: ImportConnectionFilesModalActionType.IS_IMPORTING;
  isImporting: boolean;
}

interface SelectRowAction {
  type: ImportConnectionFilesModalActionType.SELECT_ROW;
  selectedRowIndex: number;
}

interface SetConnectionFiles {
  type: ImportConnectionFilesModalActionType.SET_CONNECTION_FILES;
  connectionFiles: Array<FileListingGraphQL>;
}

interface SetProcessConnectionFiles {
  type: ImportConnectionFilesModalActionType.SET_PROCESS_CONNECTION_FILES;
  connectionFiles: Array<FileListingGraphQL>;
}

interface UpdateCurrentStepAction {
  type: ImportConnectionFilesModalActionType.UPDATE_CURRENT_STEP;
  nextStepKey: StepKey;
}

export type ImportConnectionFilesModalAction =
  | IsImportingAction
  | SelectRowAction
  | SetConnectionFiles
  | SetProcessConnectionFiles
  | UpdateCurrentStepAction;

export default function importConnectionFilesModalReducer(
  state: ImportConnectionFilesModalState,
  action: ImportConnectionFilesModalAction
): ImportConnectionFilesModalState {
  switch (action.type) {
    case ImportConnectionFilesModalActionType.IS_IMPORTING:
      return produce(state, (draftState) => {
        draftState.isImporting = action.isImporting;
      });
    case ImportConnectionFilesModalActionType.SELECT_ROW: {
      const newSelectedRowIndices = new Set(state.selectedRowIndices);
      if (newSelectedRowIndices.has(action.selectedRowIndex)) {
        newSelectedRowIndices.delete(action.selectedRowIndex);
      } else {
        newSelectedRowIndices.add(action.selectedRowIndex);
      }
      return produce(state, (draftState) => {
        draftState.selectedRowIndices = newSelectedRowIndices;
      });
    }
    case ImportConnectionFilesModalActionType.SET_CONNECTION_FILES:
      return produce(state, (draftState) => {
        draftState.connectionFiles = action.connectionFiles;
        // TODO (BNCH-117660): Remove once we can store selected rows across search pages
        draftState.selectedRowIndices = new Set<number>();
      });
    case ImportConnectionFilesModalActionType.SET_PROCESS_CONNECTION_FILES:
      return produce(state, (draftState) => {
        draftState.selectedProcessConnectionFiles = action.connectionFiles;
      });
    case ImportConnectionFilesModalActionType.UPDATE_CURRENT_STEP: {
      return produce(state, (draftState) => {
        draftState.currentStepKey = action.nextStepKey;
        draftState.statusByStep[state.currentStepKey] = StepItemStatus.DONE;
        draftState.statusByStep[action.nextStepKey] = StepItemStatus.UNVISITED;
        draftState.selectedRowIndices = new Set<number>();
        draftState.isImporting = false;
      });
    }
    default:
      return state;
  }
}
